function formatStory(storyId: string | number, storyTitle: string): string {
	return `${storyId}-${storyTitle}`;
}

export default formatStory;
